import { render, staticRenderFns } from "./PCBuilderIntel.vue?vue&type=template&id=ba38d090&"
import script from "./PCBuilderIntel.vue?vue&type=script&lang=js&"
export * from "./PCBuilderIntel.vue?vue&type=script&lang=js&"
import style0 from "./PCBuilderIntel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports